export enum VehiculoCombustible {
  GNC = 'GNC',
  DIESEL = 'diesel',
  NAFTA = 'nafta',
  HIBRIDO = 'hibrido',
  ELECTRICO = 'electrico'
}
